import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  padding: 1.528vw;
  background-color: ${(props) => props.theme.colors.white};
`;
